import { Link } from "react-router-dom";

const NoPageFound: React.FC = () => {
    return (
        <div style={{minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <div className="text-center">
                <h1 className="display-1 font-weight-bold">404</h1>
                <h2 className="mb-4">Page Not Found</h2>
                <p className="lead mb-4">The page you are looking for doesn't exist or has been moved.</p>
                <Link to="/" className="btn btn-info btn-lg">Back to Home</Link>
            </div>
        </div>
    );
};

export default NoPageFound;
